(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/components/kambi-widget-utils/test/prescript.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/components/kambi-widget-utils/test/prescript.js');
svs.oddset_kambi = svs.oddset_kambi || {};
svs.oddset_kambi.data = svs.oddset_kambi.data || {};
svs.oddset_kambi.data.seoArticlesTargets = svs.oddset_kambi.data.seoArticlesTargets || {};

svs.oddset_kambi = svs.oddset_kambi || {};
svs.oddset_kambi.components = svs.oddset_kambi.components || {};
svs.oddset_kambi.components.kambiWidgetUtils = svs.oddset_kambi.components.kambiWidgetUtils || {};


 })(window);